export const tituloInfo1 = 'Valor da sessão';
// export const tituloInfo2 = 'Reembolso Convênio';
export const tituloInfo2 = 'Formas de Pagamento';
export const tituloInfo3 = 'Plano de Saúde e Convênio';
export const tituloInfo4 = 'Terapia On-line';
export const tituloInfo5 = 'Frequência e Duração do Processo';
export const tituloInfo6 = 'Agendamento';